export function showActivityBackground({
  isIntroduction,
  backgroundVisibility,
  isLoading,
}: {
  isIntroduction: boolean;
  backgroundVisibility: boolean;
  isLoading: boolean;
}) {
  // always show backgrounds on the introduction activity
  if (isIntroduction) {
    return true;
  }
  return !isLoading && backgroundVisibility;
}
